<template>
    <section>
    <b-card class="mb-1 sticky-top" style="height: 58px; font-family: NanumBarunGothic; padding: 1.0rem 1.5rem;" no-body>
      <b-row style="margin-top: 0px;">
        <b-col xl="2" md="2" sm="2">
          <div
            class="main-menu"
            style="font-family: 'NanumBarunGothic';"
          >
            <!-- main menu header-->
            <div class="d-flex align-items-center" style="height: 10%; margin-top: 4%;">
              <slot
                name="header"
              >
                <ul>
                  <!-- Logo & Text -->
                  <li>
                    <span>
                      <b-img :src="appLogoImage" alt="logo" style="width: 80%; margin-left: -2px;"/>
                    </span>
                  </li>
                </ul>
              </slot>
            </div>
            <!-- / main menu header-->
          </div>
        </b-col>
        


        <b-col xl="7" md="7" sm="7">
          <div id="voteMenu" style="margin-left: 0rem;">
            <b-form-radio
              class="btn-radio"
              v-model="selectedVoteMenu"
              value="trend"
              size=""
              button
              @change="voteMenuClick('trend')"
              style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
            >
              점유율 분석
            </b-form-radio>
            <b-form-radio
              class="btn-radio"
              v-model="selectedVoteMenu"
              value="emotion"
              size=""
              button
              @change="voteMenuClick('emotion')"
              style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
            >
              감성 분석
            </b-form-radio>
          </div>
        </b-col>



        <b-col xl="1" md="1" sm="1">
          <b-row class="d-flex align-items-center justify-content-center">
            <span class="bg-secondary round text-white ml-2 mt-1" style="background-color: #404040 !important; width: 100%; font-size: 16px; font-weight: 400; margin-right: 5px; text-align: center;">기간</span>
          </b-row>
        </b-col>
        <b-col xl="2" md="2" sm="2" class="d-flex align-items-start" style="margin-top: -3px;">
          <b-row class="d-flex align-items-center justify-content-start">
            <vue-select
              class="first-class"
              label="title"            
              :options="weekList"
              :clearable="true"
              v-model="selectedWeek"
              placeholder="주별(전체)"
              style="height: 32px; width: 250px; text-align: center; font-size: 14px; margin-left: 5px;"
            >
            </vue-select>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    
    <b-card ref="comPrintArea1" class="mb-1" style="font-family: 'NanumBarunGothic'; padding: 0.2rem 1.5rem;" no-body>
      <b-row style="margin-top: 10px;">
        <b-col style="text-align:center;">
          <h1>연관어 감성</h1>
        </b-col>
      </b-row>
      <b-row style="margin-top: 5px;">
        <b-col id="competitionBarCol" xl="6" md="6" sm="6">
          <b-row>
            <b-col style="text-align:center;">
              <h3>후보별</h3>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="graphic-container">
                <vote-emotion-chart-bar
                  :barChartData="barChartData"
                  :barChartCategory="barChartCategory"
                  :totalFreq="totalFreq"
                />
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col id="competitionDonutCol" xl="6" md="6" sm="6">
          <b-row>
            <b-col style="text-align:center;">
              <h3>정당별</h3>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <vote-chart-donut
                :donutChartData="donutChartData"
                :totalFreq="totalFreq"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <b-card ref="comPrintArea2" class="mb-1" style="font-family: 'NanumBarunGothic'; padding: 0.2rem 1.5rem;" no-body>
      <b-row style="margin-top: 10px;">
        <b-col cols="12" style="text-align:center;">
          <h1>검색량 트랜드</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2" style="margin-bottom: 10px;">
          <vue-select
              class="first-class"
              label="title"            
              :options="typeList"
              :clearable="false"
              v-model="selectedType"
              placeholder="후보별"
              style="height: 32px; width: 200px; text-align: center; font-size: 14px; margin-left: 5px;"
            >
          </vue-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <vote-chart-line
            :voteChartLine="voteChartLineSeries(lineChartData)"
            :lineChartCategories="lineChartCategories"
            :lineChartDesc="lineChartDesc"
            :isChartInit="lnChartInit"
            id="competitionChartLine"
          />
        </b-col>
      </b-row>
    </b-card>

    </section>
</template>



<script>
import { 
    BCard, 
    BCol, 
    BRow, 
    BCardBody, 
    BButton,
    BCardText,
    BFormRadio, 
    BTable, 
    BPagination,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BTooltip,
    BImg,
} from "bootstrap-vue";





import vSelect from "vue-select";
import moment from "moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent";


import VoteChartDonut from "@/views/vote2025/components/VoteChartDonut.vue";
import VoteEmotionChartBar from "@/views/vote2025/components/VoteEmotionChartBar.vue";
import VoteChartLine from "@/views/vote2025/components/VoteChartLine.vue";


import CisVoteService from "@/services/cis-vote.service";
import CategoryService from "@/services/category.service";

import useAppConfig from "@core/app-config/useAppConfig";
import { $themeConfig } from "@themeConfig";

import axios from "axios"

const cancelToken = axios.CancelToken;
var source = cancelToken.source();


var sel_category = 9999;

export default {
  name: "voteTrend",
  components: {
    BCard,
    BCol,
    BRow,
    BCardBody,
    vSelect,
    BButton,
    BTable,
    BPagination,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BTooltip,
    BImg,
    BFormRadio,

    VoteChartDonut,
    VoteEmotionChartBar,
    VoteChartLine,
  },
  data() {
    return {

      weekList : [
        {'title' : 'TOTAL (3/30~)', 'id': 'total'}
        ,{'title' : '4월 1주차 (3/31~4/6)', 'id': '41'}
        ,{'title' : '4월 2주차 (4/7~4/13)', 'id': '42'}
        ,{'title' : '4월 3주차 (4/14~4/20)', 'id': '43'}
      ],

      typeList:[
        {'title' : '후보별', 'id': 'c'},
        {'title' : '정당별', 'id': 'p'},
        {'title' : '대선', 'id': 'v'}
      ],

      selectedWeek: {'title' : 'TOTAL (3/30~)', 'id': 'total'},
      selectedType: {'title' : '후보별', 'id': 'c'},

      selectedVoteMenu: "emotion",

      candidateList: [],

      selectedBrandList: [],


      isBusy: false,
      lnChartInit: false,

      totalFreq: 0,
      donutChartData: [],
      barChartData: [],
      barChartCategory: [],
      height: 0,

      
      selectedOptions: [],

      lineChartCategories: [],
      lineChartData: [],
      lineChartDesc: [],


      fetchGroups: null,

    };
  },
  computed: {
    check_voteMenu() {
      return this.$store.getters.getSelectedVoteMenu
    }
  },
  watch: {
    check_voteMenu(value) {
      this.selectedVoteMenu = value
    },
    selectedWeek(){
      console.log('--- change selectedWeek ---')
      console.log(this.selectedWeek)
      if(this.selectedWeek){
        console.log(this.selectedWeek.id)        
      }else{
        this.selectedWeek = this.weekList[0]
      }
      // this.loadDataDonutBar()
      this.loadDataStack()
      this.loadDataLine()
    },
    selectedType(){
      this.loadDataLine()
    }
    
    
  },
  methods: {
    voteMenuClick(mode) {      
      this.$store.dispatch('callVoteMenu', { voteMenu: mode })

      switch(mode) {
        case 'trend':
          this.$router.push({ name: "vote2025t" }).catch(() => {});
          break;
        case 'emotion':
          this.$router.push({ name: "vote2025e" }).catch(() => {});
          break;
        case 'relation':
          this.$router.push({ name: "vote2025r" }).catch(() => {});
          break;
      }
    },
    
    matchColName(propNm) {
      return colNameDict[propNm]
    },

    removeNullString(arrString) {
      var ret = [];

      for (const str of arrString) {
        if(str.length > 0) {
            ret.push(str);
        }
      }

      return ret;
    },



    async loadDataStack(){
      console.log("---------- loadDataStack ----------");

      this.barChartData = []
      this.barChartCategory = []

      var week = 'total'
      if (this.selectedWeek){
        week = this.selectedWeek.id
      }

      console.log('week : ', week)
      var startDate = ''
      var endDate = ''

      switch(week){
        case 'total': 
                startDate = '2025-03-30';
                endDate = this.getYesterday().toISOString().split('T')[0];
                break;
        case '41': 
                startDate = '2025-03-31';
                endDate = '2025-04-06';
                break;
        case '42': 
                startDate = '2025-04-07';
                endDate = '2025-04-13';
                break;
        case '43': 
                startDate = '2025-04-14';
                endDate = '2025-04-20';
                break;
        case '44': 
                startDate = '2025-04-21';
                endDate = '2025-04-27';
                break;
        case '51': 
                startDate = '2025-04-28';
                endDate = '2025-05-04';
                break;
        case '52': 
                startDate = '2025-05-05';
                endDate = '2025-05-11';
                break;
        case '53': 
                startDate = '2025-05-12';
                endDate = '2025-05-18';
                break;
        case '54': 
                startDate = '2025-05-19';
                endDate = '2025-05-25';
                break;
        case '55': 
                startDate = '2025-05-26';
                endDate = '2025-06-01';
                break;
        case '61': 
                startDate = '2025-06-02';
                endDate = '2025-06-08';
                break;
        case '62': 
                startDate = '2025-06-09';
                endDate = '2025-06-15';
                break;
        case '63': 
                startDate = '2025-06-16';
                endDate = '2025-06-22';
                break;
        default: 
                startDate = '2025-03-31';
                endDate = this.getYesterday().toISOString().split('T')[0];
      }

      console.log('startDate : ', startDate)
      console.log('endDate : ', endDate)

      const stackData = await CisVoteService.getVoteDataStack({
        startDate : startDate,
        endDate : endDate,
      }, source);
      if (stackData && stackData.status === 200) {
        console.log('-- getVoteDataStack --')
        console.log(stackData)

        this.totalFreq = stackData.data.data[0].total
        var negative_f = []
        var negative_r = []
        var positive_f = []
        var positive_r = []
        for(const item of stackData.data.data) {
          this.barChartCategory.push(item.candidate)
          negative_f.push(item.freqN)
          negative_r.push(item.rateN)
          positive_f.push(item.freqP)
          positive_r.push(item.rateP)
        }
        
        this.barChartData.push(negative_r)
        this.barChartData.push(positive_r)

        console.log(this.barChartCategory)
        console.log(this.barChartData)
        console.log(this.totalFreq)
      
      }
      return


      

      const response = await CisVoteService.getVoteDataDonutBar({
        startDate : startDate,
        endDate : endDate,
      }, source);



      if (response && response.status === 200) {
        console.log('-- getVoteDataDonutBar --')
        console.log(response)

        // total freq update
        this.totalFreq = response.data.data.donutData[0].totalFreq
        
        // donut chart update
        this.donutChartData = [response.data.data.donutData[0].kukminFreq, response.data.data.donutData[0].deobulFreq, response.data.data.donutData[0].kaehyukFreq
        , response.data.data.donutData[0].jinboFreq, response.data.data.donutData[0].jokukFreq, response.data.data.donutData[0].kibonFreq, response.data.data.donutData[0].sahaeFreq
        , response.data.data.donutData[0].jeongiFreq, response.data.data.donutData[0].saemiraeFreq, response.data.data.donutData[0].etcFreq]
        // bar chart update
        this.barChartData = []
        this.barChartCategory = []
        this.candidateList = []
        
        var idx_barData = 0

        for(const item of response.data.data.barData) {
          idx_barData+=1
          this.barChartData.push(item.rate)
          this.barChartCategory.push(item.candidate)
          this.candidateList.push(item.candidate)
        }
      }
    },



































    async loadDataDonutBar(){
      console.log("---------- loadDataDonutBar ----------");

      this.donutChartData = []
      this.barChartData = []
      this.barChartCategory = []
      
      this.brand_share_rate = 0.0
      this.nonbrand_share_rate = 0.0

      var week = 'total'
      if (this.selectedWeek){
        week = this.selectedWeek.id
      }

      console.log('week : ', week)
      var startDate = ''
      var endDate = ''

      switch(week){
        case 'total': 
                startDate = '2025-03-30';
                endDate = this.getYesterday().toISOString().split('T')[0];
                break;
        case '41': 
                startDate = '2025-03-31';
                endDate = '2025-04-06';
                break;
        case '42': 
                startDate = '2025-04-07';
                endDate = '2025-04-13';
                break;
        case '43': 
                startDate = '2025-04-14';
                endDate = '2025-04-20';
                break;
        case '44': 
                startDate = '2025-04-21';
                endDate = '2025-04-27';
                break;
        case '51': 
                startDate = '2025-04-28';
                endDate = '2025-05-04';
                break;
        case '52': 
                startDate = '2025-05-05';
                endDate = '2025-05-11';
                break;
        case '53': 
                startDate = '2025-05-12';
                endDate = '2025-05-18';
                break;
        case '54': 
                startDate = '2025-05-19';
                endDate = '2025-05-25';
                break;
        case '55': 
                startDate = '2025-05-26';
                endDate = '2025-06-01';
                break;
        case '61': 
                startDate = '2025-06-02';
                endDate = '2025-06-08';
                break;
        case '62': 
                startDate = '2025-06-09';
                endDate = '2025-06-15';
                break;
        case '63': 
                startDate = '2025-06-16';
                endDate = '2025-06-22';
                break;
        default: 
                startDate = '2025-03-31';
                endDate = this.getYesterday().toISOString().split('T')[0];
      }

      console.log('startDate : ', startDate)
      console.log('endDate : ', endDate)
      

      const response = await CisVoteService.getVoteDataDonutBar({
        startDate : startDate,
        endDate : endDate,
      }, source);



      if (response && response.status === 200) {
        console.log('-- getVoteDataDonutBar --')
        console.log(response)

        // total freq update
        this.totalFreq = response.data.data.donutData[0].totalFreq
        
        // donut chart update
        this.donutChartData = [response.data.data.donutData[0].kukminFreq, response.data.data.donutData[0].deobulFreq, response.data.data.donutData[0].kaehyukFreq
        , response.data.data.donutData[0].jinboFreq, response.data.data.donutData[0].jokukFreq, response.data.data.donutData[0].kibonFreq, response.data.data.donutData[0].sahaeFreq
        , response.data.data.donutData[0].jeongiFreq, response.data.data.donutData[0].saemiraeFreq, response.data.data.donutData[0].etcFreq]
        // bar chart update
        this.barChartData = []
        this.barChartCategory = []
        this.candidateList = []
        
        var idx_barData = 0

        for(const item of response.data.data.barData) {
          idx_barData+=1
          this.barChartData.push(item.rate)
          this.barChartCategory.push(item.candidate)
          this.candidateList.push(item.candidate)
        }
      }
    },

    async loadDataLine(){
      console.log('---------- loadDataLine ----------')
      var week = 'total'
      if (this.selectedWeek){
        week = this.selectedWeek.id
      }
      var startDate = ''
      var endDate = ''

      switch(week){
        case 'total': 
                startDate = '2025-03-30';
                endDate = this.getYesterday().toISOString().split('T')[0];
                break;
        case '41': 
                startDate = '2025-03-31';
                endDate = '2025-04-06';
                break;
        case '42': 
                startDate = '2025-04-07';
                endDate = '2025-04-13';
                break;
        case '43': 
                startDate = '2025-04-14';
                endDate = '2025-04-20';
                break;
        case '44': 
                startDate = '2025-04-21';
                endDate = '2025-04-27';
                break;
        case '51': 
                startDate = '2025-04-28';
                endDate = '2025-05-04';
                break;
        case '52': 
                startDate = '2025-05-05';
                endDate = '2025-05-11';
                break;
        case '53': 
                startDate = '2025-05-12';
                endDate = '2025-05-18';
                break;
        case '54': 
                startDate = '2025-05-19';
                endDate = '2025-05-25';
                break;
        case '55': 
                startDate = '2025-05-26';
                endDate = '2025-06-01';
                break;
        case '61': 
                startDate = '2025-06-02';
                endDate = '2025-06-08';
                break;
        case '62': 
                startDate = '2025-06-09';
                endDate = '2025-06-15';
                break;
        case '63': 
                startDate = '2025-06-16';
                endDate = '2025-06-22';
                break;
        default: 
                startDate = '2025-03-31';
                endDate = this.getYesterday().toISOString().split('T')[0];
      }

      console.log('startDate : ', startDate)
      console.log('endDate : ', endDate)

      var typeGubun = 'c'
      if (this.selectedType){
        typeGubun = this.selectedType.id
      }
      console.log('typeGubun : ', typeGubun)

      this.lnChartInit = false;

      this.lineChartData = []
      this.lineChartCategories = []
      this.lineChartDesc = []

      
      const response = await CisVoteService.getVoteDataLine({
        startDate : startDate,
        endDate : endDate,
        typeGubun : typeGubun
      }, source);

      if (response && response.status === 200) {
        console.log('-- getVoteDataLine --')
        console.log(response)

        this.lnChartInit = true;
        this.lineChartData = []
        this.lineChartCategories = []
        this.lineChartDesc = []

        for(const item of response.data.data) {
            this.lineChartData.push({
                item: item.item,
                type: 'line',
                data: item.rate.split(','),
                description: item.freq.split(','),
                hidden: true
            })

            if (this.lineChartCategories.length == 0) 
                this.lineChartCategories = item.date.split(',')
            
            this.lineChartDesc.push(item.freq.split(','))
        }
        
        // this.top_rank_brands = this.lineChartData[0].brand;
        // this.top_rank_brand_rate_diff = this.lineChartData[0].data[this.lineChartCategories.length - 1] - this.lineChartData[0].data[0];
      }
      
    },


    voteChartLineSeries(cd) {
        const chartSeries = [];

        for (const item of cd)
          chartSeries.push({ name: item.item, type: item.type, data: item.data, hidden: false })

        return chartSeries;
    },

    getToday() {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

      return year + month + day
    },

    getYesterday(){
      let d = new Date();
      d.setDate(d.getDate() -1);
      return d;
    },

    
    removeSelItem(target, sel_idx) {
      target.splice(sel_idx, 1)
      target = [...target]
    },

    abort(isReset, message) {
      console.log('---------- abort ---------- // ' + message)

      // cancel the request
      source.cancel(message);

      if (isReset)
        source = cancelToken.source();
    },
  },

  mounted(){
    console.log('---------- mounted ----------')

  },

  destroyed() {
    console.log('---------- destroyed ----------')

  },

  setup(props) {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app;
    return {
      // App Name
      appName,
      appLogoImage,
    };
  },

  async created() {
    console.log('---------- create ----------')
    this.lineChartData = [];
    this.lineChartCategories = [] 

    // this.loadDataDonutBar();
    this.loadDataStack();
    this.loadDataLine();

  },
};

</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

#competitionDonutCol .apexcharts-canvas .apexcharts-text, 
#competitionDonutCol .apexcharts-canvas .apexcharts-tooltip-text, 
#competitionDonutCol .apexcharts-canvas .apexcharts-datalabel-label, 
#competitionDonutCol .apexcharts-canvas .apexcharts-datalabel, 
#competitionBarCol .apexcharts-canvas .apexcharts-text, 
#competitionBarCol .apexcharts-canvas .apexcharts-tooltip-text, 
#competitionBarCol .apexcharts-canvas .apexcharts-datalabel-label, 
#competitionBarCol .apexcharts-canvas .apexcharts-datalabel 
{
    font-family: "NanumBarunGothic", Arial, sans-serif !important;
    font-weight: bold;
    filter: none;
}

#competitionBarCol .apexcharts-canvas .apexcharts-datalabel-label, 
#competitionBarCol .apexcharts-canvas .apexcharts-datalabel
{
  margin-left: 5rem;
}

#competitionBarCol .graphic-container {
  min-height: 480px;
  max-height: 480px;
  overflow-y: auto;
  overflow-x: hidden;
}

.first-class .vs__dropdown-menu,
.first-attribute .vs__dropdown-menu,
.second-attribute .vs__dropdown-menu
{
  padding: 0px 0px 0px 0px;
}

.mb-1 .sticky-top{
  align-self: flex-start;
}

.tooltip-inner {
  color: #333;
  background: #fff;
  border: 1px solid #F2F2F2;
  font-family: "NanumBarunGothic", Arial, sans-serif !important;
  filter: none;
  box-shadow: 1px 1px 1px #F2F2F2;
  font-weight: bold;
}

/* Hide default icon */
.comTable .table.b-table > thead > tr > th,
.comTable .table.b-table > tfoot > tr > td {
  background-image: none !important;
  vertical-align: middle !important;
}

.select-brand .v-label {
  font-size: 14px;
}

.select-brand .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 6px 0;
}

.comselectitemlist .v-list-item {
  min-height: 28px;
}

.comselectitemlist .v-list-item__content {
  padding: 5px 0;
}

.comselectitemlist .v-list-item__action {
  margin: 5px 0;
}


#voteMenu .btn-radio .btn-secondary {
  background-color: #AFAFAF !important;
  border-color: #AFAFAF !important;
  // background-color: #4E86FF !important;
  // border-color: #4E86FF !important;
  box-shadow: none;
  width: 10rem;
}

#voteMenu .btn-radio .btn-secondary.active {
  background-color: #404040 !important;
  border-color: #404040 !important;
  // background-color: #1951dc !important;
  // border-color: #1c5cff !important;
}

</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
